/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: auth-guard.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/app/middleware/register/auth-guard.js
 */
import store from '../../../stores'

export default (to, from, next) => {
    store.dispatch('userSession/checkLogin').then(() => {
        let isLogin = store.getters['userSession/isLogin']

        if (isLogin)
            next()
        else
            next({path: '/login'})
    }).catch(() => {
        next({path: '/login'})
    })
}
